// extracted by mini-css-extract-plugin
export default {"summary-card":"EarningsPage-styles-module--summary-card--XNqbo","summaryCard":"EarningsPage-styles-module--summary-card--XNqbo"};